<template>
		<div v-if="!edit">
			<c-select
				:label="'Bedrijf'"
				:horizontal="true"
				:options="endcustomers"
				v-model="name"
				:ValueName="'id,name'"
				name="name"
				@change="getProducts(id)"
				required
			/>
		</div>
		<c-sub-form name="contacts">
			<c-sub-form name="0">
				<c-personal-data
					ref="personalform"
					:edit="edit"
					:contact="(contact.contacts ? contact.contacts[0] : contact )"
				/>
			</c-sub-form>
		</c-sub-form>

		<div v-if="!edit">

			<h6 class="margin-t-40 margin-b-16">Voorraad</h6>

			<c-datepicker
				:label="'Datum levering'"
				:horizontal="true"
				:icon="true"
				name="date"
				v-model="dateDelivery"
				required
				:type="'future'"
			/>

			<c-custom-zipcode-address
				:label="'Bezorglocatie'"
				:addresses="addresses"
				v-model="pickUpAddress"
				name="address"
			/>

			<c-select v-if="bundles"
				:label="'Bundel'"
				:horizontal="true"
				:options="bundles"
				v-model="bundle"
				:ValueName="'id'"
				name="name"
				@change="getbundleproducts(bundle)">
			</c-select>

			<c-checkbox v-if="id"
				v-model="allproducts"
				:horizontal="true"
				:label="' '"
				valueName=""
				labeltext=""
				:options="[
					'Losse artikelen kiezen',
				]">
			</c-checkbox>

			<c-checkbox v-if="products"
				:label="'Voorraad'"
				:horizontal="true"
				:options="products"
				:labeltext="'name'"
				v-model="items">
			</c-checkbox>

			<c-input
				label="Ordernummer"
				:horizontal="true"
				name="order_number"
				v-model="orderNumber"
				required
			/>

			<c-input
				label="Uw referentie"
				:horizontal="true"
				name="your_reference"
				v-model="yourReference"
				required
			/>

			<c-textarea
				:label="'Opmerking'"
				:horizontal="true"
				type="textarea"
				name="description"
				v-model="description"
			/>

		</div>

</template>

<script>
import Form from '@mixins/Form';
import CPersonalData from '@components/PersonalData';
import CDatepicker from '@components/form/input/Datepicker';
import Activate from '../views/public/login/Activate.vue';
import CCustomZipcodeAddress from '@components/CustomZipcodeAddress.vue';

export default {
	mixins: [Form],
	components: {
		CPersonalData, CDatepicker, Activate, CCustomZipcodeAddress
	},
	props: {
        edit: {
            required: false
        },
		contact: {
			required: false
		},
    },
	data() {
		return {
			product_group: '',
			endcustomers: '',
			name: '',
			id: '',
			products: '',
			addresses: [],
			dateDelivery: '',
			items: [],
			companyName: '',
			pickUpAddress: {},
			parent_client_id: '',
			bundles: '',
			bundle: '',
			allproducts: '',
			orderNumber: '',
			yourReference: '',
			carrier_id: '',
			description: ''
		};
	},
	watch: {
		allproducts() {
			if(this.allproducts){
				this.product = '';
				this.items = [];
				this.getAllproducts();
			}
			else{
				this.products = ''
			}
		}
	},
	methods: {
		getData() {
			let name = this.name.split(' ');
			this.parent_client_id = name[0];
			name.shift();
			let submitData = {
                name: name.join(' '),
				delivery_type_id: this.$constants.delivery.INDIENST,
				date: this.dateDelivery,
				address: this.pickUpAddress,
				parent_client_id: this.parent_client_id,
				order_number: this.orderNumber,
				your_reference: this.yourReference,
				carrier_id: 2,
				description: this.description
			};

			let persondata = {
				contacts: []
			};

			persondata['contacts'][0] = this.$refs.personalform.getData();

			let ItemsData = {
				items: []
			};

			this.items.forEach( (component, index) => {
				ItemsData['items'][index] = {product_id: this.items[index], item_id: '', is_pickup: 0};
			});

			let data = Object.assign(submitData, persondata, ItemsData);
			return data;

		},
		clear()
		{
			this.product_group = '';
			this.endcustomers ='';
			this.name = '';
			this.id = '';
			this.products = '';
			this.addresses = [];
			this.dateDelivery = '';
			this.items = [];
			this.companyName = '';
			this.pickUpAddress = {};
			this.parent_client_id = '';
			this.bundles = '';
			this.bundle ='';
			this.allproducts = '';
			this.orderNumber = '';
			this.yourReference = '';
			this.carrier_id = '';
			this.description = ''
		},
		getbundleproducts(bundle_id){
			this.product = '';
			this.items = [];

			this.$xhr.get('/api/bundles/' + bundle_id).then( ( {result}) => {

				this.products = result.available_products;

				this.products.forEach(product => {
					this.items.push(product.id);
				})

			}).catch( (e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Bundelgegevens kunnen niet worden ingeladen'});
			});

		},
		getProducts() {
			let value = this.name.split(' ');
			this.id = value[0];
			this.$xhr.get('/api/clients/' + this.id).then( ( {result}) => {
				this.products = "";
				this.addresses = result.addresses;
				this.bundles = result.bundles;
			}).catch( (e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Klantgegevens kunnen niet worden ingeladen'});
			});
		},
		getAllproducts(){
			this.bundle = '';
			this.$xhr.get('/api/clients/' + this.id).then( ( {result}) => {
				this.products = result.available_products;
			}).catch( (e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Productgegevens kunnen niet worden ingeladen'});
			});
		}
	},
	mounted() {
		this.$xhr.get('/api/product-groups').then( ( {result}) => {
				this.product_group = result;
			}).catch( (e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Productgroepen kunnen niet worden ingeladen'});
		});

		this.$xhr.get('/api/getallendcustomers').then( ( {result}) => {
				this.endcustomers = result;
				if (this.endcustomers.length == 1) {
					this.name = `${this.endcustomers[0].id} ${this.endcustomers[0].name}`
					this.id = this.endcustomers[0].id;

					this.$xhr.get('/api/clients/' + this.endcustomers[0].id).then( ( {result}) => {
						this.products = "";
						this.addresses = result.addresses;
						this.bundles = result.bundles;
					}).catch( (e) => {
						this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Klantgegevens kunnen niet worden ingeladen'});
					});

				}
			}).catch( (e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Eindklanten kunnen niet worden ingeladen'});
		});

	}
}
</script>
